<template>
  <RadioButtonGroup direction="column">
    <RadioCard
      v-for="option in options"
      :key="option.value"
      name="screeningSensitivity"
      :value="option.value"
      :disabled="disabled"
      v-model="model"
    >
      <View direction="row" gap="sm" align="center">
        <IconTile :icon="option.icon" size="small" :color="option.color" />
        <View direction="column" gap="xs">
          <Text variant="label-medium">{{ option.label }}</Text>
          <Text variant="body-medium" color="secondary">{{ option.description }}</Text>
        </View>
      </View>
    </RadioCard>
  </RadioButtonGroup>
</template>

<script setup lang="ts">
import { IconName, IconTile, IconTileColor, RadioButtonGroup, RadioCard, Text, View } from '@tallo/design-system';

import { ScreeningSensitivity } from '../model/property-renter-requirements';

const model = defineModel<ScreeningSensitivity | null>();
withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false });

const options: Array<{
  value: ScreeningSensitivity;
  label: string;
  description: string;
  icon: IconName;
  color: IconTileColor;
}> = [
  {
    value: ScreeningSensitivity.STRICT,
    label: 'Strict',
    description: 'Only renters who meet every requirement can book a showing. Highest quality, fewer showing requests.',
    icon: 'user-check-02',
    color: 'green',
  },
  {
    value: ScreeningSensitivity.MODERATE,
    label: 'Moderate',
    description: 'Allow reasonable compromises and still keep standards. Balanced quality and showing volume.',
    icon: 'users-01',
    color: 'yellow',
  },
  {
    value: ScreeningSensitivity.OWNER_REVIEW,
    label: 'Owner review',
    description: 'No automatic rejections. Most leads possible, but you’ll manually review showing requests.',
    icon: 'users-plus',
    color: 'blue',
  },
];
</script>
